export const PERCENT_SERVICE_CALENDLY_URL_TILES = 'https://calendly.com/d/ck88-xdh-4rp'
